import moment from 'moment-timezone';
import {environment} from "environments";

(() => {
  class VisitHistoryListController {
    constructor() {
      this.BOD_1780 = ['localhost', 'dev', 'qa', 'staging', 'production'].includes(environment.constants.ENV)
    }

    formatDate(iso_date) {
      if (!iso_date) return null;
      const formatted_date = moment.tz(iso_date, this.timezone).format('DD/MMM/YY h:mm A');
      return formatted_date;
    }

  }

  angular.module('pims').component('visitHistoryTable', {
    templateUrl: 'app/components/visit-history-table/visit-history-table.html',
    controller: VisitHistoryListController,
    bindings: {
      pagination: '=',
      sortBy: '=',
      sortOrder: '=',
      onPageChange: '&',
      onSort: '&',
      visits: '<',
      profile: '<',
      timezone: '='
    }
  });
})();
